"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var weakKey_exports = {};
__export(weakKey_exports, {
  weakKey: () => weakKey
});
module.exports = __toCommonJS(weakKey_exports);
var w = /* @__PURE__ */ new WeakMap();
var weakKey = function(item) {
  var _w_get;
  return (_w_get = w.get(item)) !== null && _w_get !== void 0 ? _w_get : (function() {
    var k = `${Math.random()}`;
    w.set(item, k);
    return k;
  })();
};
//# sourceMappingURL=weakKey.js.map
